// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const params = {
  cardId: __t.uuid(),
  accessCode: __t.string(),
  interestDollarAmount: __t.i64(),
  firstName: __t.option(__t.string()),
  lastName: __t.option(__t.string()),
  supportiveMessage: __t.option(__t.string()),
  consentToDisplay: __t.bool(),
};
export const returnType = __t.unit()